import {
  Directive,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { FileDetails } from 'src/app/product-capture/import-product/import-product.consts';

@Directive({
  selector: '[fileDragAndDrop]',
})
export class FileDragAndDropDirective {
  @Output()
  filesChange = new EventEmitter<FileDetails[]>();

  @Output()
  dragOver = new EventEmitter<DragEvent>();

  @Output()
  dragLeave = new EventEmitter<DragEvent>();

  @Output()
  dragError = new EventEmitter<string>();

  @Input()
  allowMultipleFiles = true;

  @Input()
  fileDragAndDrop: boolean;

  isDragginOver = false;

  constructor() {}

  @HostListener('dragover', ['$event'])
  onDragOver(event: DragEvent): void {
    this.stopAndPrevent(event);

    if (this.isDragginOver) {
      return;
    }

    this.dragOver.emit(event);
    this.isDragginOver = true;

    // Change styles?
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent): void {
    this.isDragginOver = false;
    this.dragLeave.emit(event);
  }

  @HostListener('drop', ['$event'])
  onDrop(event: DragEvent): void {
    if (!this.fileDragAndDrop) {
      return;
    }

    this.stopAndPrevent(event);
    const allFiles: FileDetails[] = [];

    const files = Array.from(event.dataTransfer.files);

    for (let file of files) {
      const fileDetails: FileDetails = {
        file,
      };

      allFiles.push(fileDetails);
    }

    if (files.length > 1 && !this.allowMultipleFiles) {
      allFiles.length = 1;
    }

    this.filesChange.emit(allFiles);
  }

  stopAndPrevent(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
  }
}
